module.exports = __webpack_public_path__ + "img/sophie_living_logo.de8f0d11.png";